<template>
<transition name="fade"
            mode="out-in">
	<b-alert v-if="dismissCountDown"
	         :show="dismissCountDown"
	         dismissible
	         :key="true"
	         :variant="type"
	         @dismissed="dismissCountDown = 0"
	         @dismiss-count-down="countDownChanged">
		{{ message }}
	</b-alert>
</transition>
</template>
<script>
export default {
	name: 'flash-messages-item',
	data: () => ({
		dismissCountDown: 4,
		showDismissibleAlert: false
	}),
	props: {
		type: {
			type: String,
			default: 'primary'
		},
		message: {
			type: String,
			required: true
		}
	},
	methods: {
		countDownChanged(dismissCountDown) {
			this.dismissCountDown = dismissCountDown;
		}
	}
}
</script>
<style lang="scss">
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// FlashMessagesItem.vue?8f00ae0c